export default "__VITE_ASSET__D$U5Prx9__"